import { useState, useCallback } from 'react';

/**
 * Hook für Ortho-Modus (nur 0°/90° Linien).
 * Wie in Rhino/AutoCAD für präzises rechtwinkliges Zeichnen.
 */
export function useOrthoMode(initialValue = false) {
  const [orthoMode, setOrthoMode] = useState(initialValue);

  const toggleOrtho = useCallback(() => {
    setOrthoMode(prev => !prev);
  }, []);

  const enableOrtho = useCallback(() => {
    setOrthoMode(true);
  }, []);

  const disableOrtho = useCallback(() => {
    setOrthoMode(false);
  }, []);

  return {
    orthoMode,
    setOrthoMode,
    toggleOrtho,
    enableOrtho,
    disableOrtho,
  };
}

export default useOrthoMode;
